// extracted by mini-css-extract-plugin
module.exports = {"GiftIcon":"SVGIcons_GiftIcon__H-hNY","Subnav":"SVGIcons_Subnav__2YyD2","ActiveGalleryIcon":"SVGIcons_ActiveGalleryIcon__3-JYu"};